<template>
  <div class="ur-dropdown ur-input" :class="dropdownClass">
    <div class="ur-dropdown__title" @click="toggleItem" :class="dropdownTitleClass">
      <div class="ur-dropdown__selected" :title="getSelectedItemText"><span>{{getSelectedItemText}}</span></div>
      <ur-icon-wrapper style="width:16px;margin-left:12px;">
        <ur-icon class="ur-dropdown__icon" icon="expand_menu" size="10px" :style="caretStyle" />
      </ur-icon-wrapper>
    </div>
    <div class="ur-dropdown__downwrap" v-show="isItemShowing" ref="floating" v-ur-attach-root v-click-outside.anchor="toggleItemOuter">
      <div class="ur-dropdown__item ur-dropdown__selectall" :class="[dropdownItemSize]" v-show="selectAll" @click="clickSelectAll">
        <ur-checkbox :checked="selectAllChecked" :checked-icon="selectAllCheckedIcon" @click="clickSelectAll">Select All</ur-checkbox>
      </div>
      <div class="ur-dropdown__items">
        <div class="ur-dropdown__item" :class="[dropdownItemSize]" v-for="(item, idx) in items" :key="idx" @click="onClickItem(item)">
          <div class="ur-dropdown__label">
            <ur-checkbox :value="item" :checked="selected" :sm="$_size === 'small'" @click="onClickItem(item)">{{getText(item)}}</ur-checkbox>
          </div>
        </div>
      </div>
      <div class="ur-dropdown__apply ur-dropdown__apply_pos" v-show="applyBtn">
        <ur-button @click="onApplyClick">Apply</ur-button>
      </div> 
    </div>
    <div v-if="messageShow"
          class="ur-dropdown__message ur-validator__message"
          :class="messageClass">
      {{messageShow}}
    </div>
  </div>
</template>
<script>
  const UNSELECT_DROPDOWN_TITLE = "Select";
  const DEFAULT_PLACEHOLDER = "Input value";
  const DEFAULT_ITEM_TEXT = "text";
  const DEFAULT_ITEM_VALUE = "value";
  import urDropdown from '../urDropdown/urDropdown';
  // ur-multi-dropdown은 ur-dropdown을 상속받은 컴포넌트 입니다. ur-dropdown의 모든 속성을 그대로 사용합니다.
  // #ur-multi-dropdown is a component that inherits ur-dropdown. Accept all the properties of ur-dropdown.
  export default {
    name: "ur-multi-dropdown",
    extends: urDropdown,
    props: {
      // $ver: v0.1.2
      // $v-model
      // tags: IDE
      // 드랍다운 리스트의 선택된 값 입니다.
      // #The selected value in the drop-down list.
      value: {
        type: Array,
        validator: function(val) {
          return Array.isArray(val);
        },
        default: () => []
      },
      // $ver: v0.1.2
      // Apply 버튼을 표시합니다.
      // #Display the Apply button.
      // $default: false
      // $tags: IDE
      applyBtn: {
        type: Boolean,
        default: false
      },
      // $ver: v0.1.2
      // Select All 기능을 표시합니다.
      // #Displays the Select All function.
      // $default: false
      // $tags: IDE
      selectAll: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        selected: [],
        initSelected: []
      }
    },
    watch: {
        isItemShowing(v,w) {
            if(v) {
                this.$refs.floating.open(); this.$emit('toggle-floating', true);;
            } else {
                this.$refs.floating.close(); this.$emit('toggle-floating', false);;
            }
            this.$emit('toggle-item', v);
        }
    },
    computed: {
      getSelectedItemText() {

        let _selected;
        if(this.applyBtn){
          _selected = this.initSelected;
        }else{
          _selected = this.selected;
        }

        if (_selected.length === 0) {
          return this.placeholder ? this.placeholder : UNSELECT_DROPDOWN_TITLE;
        } else {
          let itemText = [];
          _selected.forEach(item => {
            if (typeof(this.itemText) === 'function') {
              itemText.push(this.itemText(item));
            } else {
              itemText.push(item[this.itemText]);
            }
          });
          return itemText.sort().join(", ");
        }
      },
      selectAllChecked() {
        return (this.selected.length > 0);
      },
      selectAllCheckedIcon() {
        return (this.selected.length === this.items.length) ? 'checked' : 'indeterminate';
      },
    },
    created() {
      //초기값 표시 되게끔 selected에 넣어줌
      this.selected = this.value

      let initItems = this.selected.map(initItem => {
        if(typeof initItem === 'string') {
          return initItem;
        } else if (typeof initItem === 'object') {
          return this.findItem(initItem);
        }
        return;
      })

      this.selected.length = 0
      initItems.forEach(item => this.selected.push(item));
      this.initSelected = this.selected.slice();
      this.$emit('input', this.selected);
      // 내용은 같은데 다른 객체일 경우 객체의 value 값 비교해서 넣어줌
    },
    methods: {
      onClickItem(item) {
        if (this.selected.indexOf(item) >= 0) {
          this.selected.splice(this.selected.indexOf(item), 1);
        } else {
          this.selected.push(item);
        }
        if (!this.applyBtn) {
          this.$emit('input', this.selected);
        }
      },
      toggleItem(event) {
        let flag = !this.isItemShowing;
        if (this.applyBtn && flag) {
          this.selected = this.value.slice();
        }
        this.$root.$el.click();
        this.isItemShowing = flag;
      },
      toggleItemOuter(e) {
        this.isItemShowing = false;
      },
      onApplyClick(e) {
        this.$emit('input', this.selected.slice());
        this.isItemShowing = false;
        this.initSelected = this.selected.slice();
      },
      clickSelectAll(event) {
        if (this.selected.length === this.items.length) {
          this.selected = [];
        } else {
          this.selected = this.items.slice();
        }
        this.$emit('input', this.selected)
      },
      findItem(val) {
        for(let i = 0 ; i < this.items.length ; i++) {
          let item = this.items[i];
          if(item['value'] === val['value']){
            return item;
          }
        }
        return null;
      }
    },
  }
</script>